import React from 'react';
import createSVG from './createSVG';

const DownloadIcon = ({style}) => (
  <path style={style} fill="none" fillRule="evenodd" stroke="#7D7D7D" strokeWidth="1.5" d="M11.505 15.6H3V1.5h19.805v14.1H14.3m-1.398-5.875V25l-3.35-2.82M12.9 25l3.352-2.82" strokeLinecap="round" strokeLinejoin="round"/>
);

export default createSVG(DownloadIcon);
